import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  data: []
};

const brands = (state = initialState, action) => {
  switch (action.type) {
    case constant.BRANDS_LOADING:
      return { ...state, loading: true };
    case constant.ADD_BRANDS_LIST:
      return { loaded: true, loading: false, data: action.payload };
    default:
      return state;
  }
}



export default brands;